export const gray = {
  g1: '#F5F5F5',
  g2: '#F0F0F0',
  g3: '#E0E0E0',
  g4: '#CCCCCC',
  g5: '#B8B8B8',
  g6: '#A3A3A3',
  g7: '#8F8F8F',
  g8: '#7A7A7A',
  g9: '#666666',
  g10: '#525252',
  g11: '#3D3D3D',
  g12: '#303030',
  g13: '#292929',
  g14: '#262626',
  g15: '#212121',
  g16: '#1D1D1D',
  g17: '#181818',
  g18: '#141414',
  g19: '#050505',
  g0s: `rgba(0, 0, 0, 0.512)`
}

export const purple = {
  p1: '#9765E9',
  p2: '#8C59DF',
  p3: '#814CD9',
  p4: '#743ECD',
  p5: '#6A32C5',
  p6: '#642BC1',
  p7: '#5C24B7',
  p8: '#551EAD',
  p9: '#511CA6',
  p10: '#471597',
  p11: '#41128E',
  p12: '#370A80',
  p13: '#370A80',
  p14: '#2D056C',
  p15: '#280364',
  p16: '#210057',
  p17: '#1D0043',
  p18: '#180030',
  p19: '#100021',
  p4s: `hsl(263,59%,35%)`
}
